import Civilite from '@/generated/classes/Civilite';
export default class CiviliteExtend extends Civilite {
  constructor() {
    super();
  }
}
